import { Link, useTheme } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const isDocsHost = () =>
  window.location.hostname === `docs.${process.env.ROOT_DOMAIN}` ||
  window.location.hostname.startsWith('docs.')

const DocLink = ({ text, url, docsPage }) => {
  const subdomainRaw = window.location.hostname.split('.')[0]
  const subdomain = subdomainRaw === 'ambunet' ? null : subdomainRaw

  if (docsPage) {
    return (
      <>
        <Link
          href={`http${window.location.hostname !== 'localhost' ? 's' : ''}://${window.location.host}${isDocsHost() ? '' : '/docs'}${url}`}
          sx={{ fontWeight: 700, color: '#1E7F88' }}
        >
          {text}
        </Link>{' '}
      </>
    )
  }

  if (!subdomain) {
    return (
      <>
        <strong style={{ color: '#1E7F88' }}>{text}</strong>{' '}
      </>
    )
  }
  return (
    <>
      <Link
        href={`http${window.location.hostname !== 'localhost' ? 's' : ''}://${window.location.host}${url}`}
        target="_blank"
        sx={{ fontWeight: 700, color: '#1E7F88' }}
      >
        {text}
      </Link>{' '}
    </>
  )
}

export default DocLink
